import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '@app/core/store/app.state';
import { Observable, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { TokenStorageService } from "@app/core/services/token-storage.service";
import { UserRoles } from "@app/core/enums/userRoles.enum";
import {selectIsAuthenticated} from "@app/core/store/userAuth/userAuth.selectors";

@Injectable({
  providedIn: 'root'
})

// Inverse of userAuth guard. This works with redirects.routing.ts
// userTypeRedirect, but is used to automatically redirect away from
// the login page if the url is specifically entered.
export class LoginPageGuard implements CanActivate {
  constructor(
    private store: Store<AppState>,
    private router: Router,
    private tokenStorageService: TokenStorageService
) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    console.log("Running");
    return this.store.select(selectIsAuthenticated).pipe(
      take(1),
      map((isAuth) => {
        // This seems like it _might_ be necessary, but I can't think of what would set isAuthenticated without a token.
        // const hasToken = !!this.tokenStorageService.getToken();
        // console.log("has token", hasToken);
        // const isAuthenticated = isAuth || hasToken;
        const isAuthenticated = isAuth;
        console.log("is auth", isAuth);

        if (isAuthenticated) {
          const user = this.tokenStorageService.getEffectiveUser();
          if(user != null) {
            switch (user.role) {
              case UserRoles.referralUser:
                this.router.navigate(['/ref-dashboard']);
                break;
              case UserRoles.adminUser:
                this.router.navigate(['/admin-dashboard']);
                break;
              case UserRoles.workCompUser:
                this.router.navigate(['/wc-dashboard']);
                break;
              default:
                this.router.navigate(['/portal-login']);
                break;
            }
          }
        }
        return !isAuth;
      })
    );
  }
}
